import angular from "angular";

angular
    .module('app')
    .component('registerForm', {
        template: require('./register-form.html'),
        controller: ['$http', '$document', '$timeout', '$interval', 'Notifier', 'trans', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, $document, $timeout, $interval, Notifier, trans) {

    let $ctrl = this;

    $ctrl.step = 1;

    $ctrl.phoneMasks = [
        {country: 'Kazakhstan', country_code: 'KZ', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Turkish', country_code: 'TR', phone_code: '+90', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Russian', country_code: 'RU', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Usa', country_code: 'USA', phone_code: '+1', phone_mask: '+1 (999) 999-99-99'},
        {country: 'UAE', country_code: 'UAE', phone_code: '+971', phone_mask: '+\\971 (999) 99-9999'},
        {country: 'SPAIN', country_code: 'SPA', phone_code: '+34', phone_mask: '+34 (999) 999-999'}
    ];

    $ctrl.selectedMask = $ctrl.phoneMasks[0];

    $ctrl.phone = null;
    $ctrl.name = null;
    $ctrl.lastName = null;
    $ctrl.password = null;
    $ctrl.passwordConfirm = null;
    $ctrl.registerSessionId = null;

    $ctrl.$onInit = function (changes) {
        focusOnPhone();
    };

    function focusOnPhone() {
        $timeout(function () {
            $document[0].getElementById('register-phone-input').focus();
        }, 300);
    }

    $ctrl.maskChanged = function () {
        $ctrl.phone = null;
        focusOnPhone();
    };

    $ctrl.sendCode = function () {

        if ($ctrl.sendCodeLoading) {
            return;
        }

        $ctrl.sendCodeLoading = true;
        $ctrl.sendCodeErrorMessage = null;
        $ctrl.validationErrors = null;

        let phone = $ctrl.phone.replace(/\D/g, '');

        $http
            .post('/register/send-code', {phone})
            .then(
                function (response) {
                    $ctrl.registerSessionId = response.data.id;
                    $ctrl.step = 2;
                    $ctrl.code = [null, null, null, null];
                    $ctrl.sendCodeLoading = false;
                    $ctrl.codeCheckStatus = null;
                    resetSendCountdown(60);

                    $timeout(function () {
                        focusOnCodeInput(0);
                    }, 300);
                },
                function (error) {
                    $ctrl.sendCodeLoading = false;
                    if (error.status == 422) {
                        $ctrl.validationErrors = error.data.errors;
                    } else {
                        $ctrl.sendCodeErrorMessage = error.data.message || 'Undefined error';
                    }
                }
            );
    };

    function resetSendCountdown(sec) {
        if ($ctrl.countdownInterval) {
            $interval.cancel($ctrl.countdownInterval);
            $ctrl.countdownInterval = null;
        }

        $ctrl.countdown = sec;

        $ctrl.countdownInterval = $interval(function () {
            if ($ctrl.countdown) {
                $ctrl.countdown--;
            } else {
                $interval.cancel($ctrl.countdownInterval);
            }
        }, 1000);
    }

    function focusOnCodeInput(ind) {
        $document[0].getElementById('code-input-' + ind).focus();
    }

    function blurFromCodeInput(ind) {
        $document[0].getElementById('code-input-' + ind).blur();
    }

    $ctrl.codeInputItemFilled = function (ind) {

        if (!$ctrl.code[ind]) {
            return;
        }

        if (ind + 1 < $ctrl.code.length) {
            focusOnCodeInput(ind + 1);
        } else {
            blurFromCodeInput(ind);
            tryToSend();
        }

        function tryToSend() {
            let isComplete = true;
            for (let i = 0; i < $ctrl.code.length; i++) {
                if (!$ctrl.code[i]) {
                    isComplete = false;
                }
            }
            if (isComplete) {
                checkCode();
            }
        }
    };

    $ctrl.codeInputKeyDown = function (event, ind) {
        if (event.key == "Backspace" && !$ctrl.code[ind] && ind) {
            $timeout(function () {
                focusOnCodeInput(ind - 1);
            });
        }
    };

    function checkCode() {
        $ctrl.codeCheckLoading = true;
        $http
            .post('/register/check-code', {
                register_session_id: $ctrl.registerSessionId,
                code: $ctrl.code.join('')
            })
            .then(
                function (response) {
                    $ctrl.codeCheckStatus = response.data.status;
                    $ctrl.codeCheckLoading = false;

                    if ($ctrl.codeCheckStatus == 'success') {
                        $timeout(function () {
                            $ctrl.step = 3;
                        }, 1000);
                    } else {
                        $timeout(function () {
                            $ctrl.codeCheckStatus = null;
                            for (let i = 0; i < $ctrl.code.length; i++) {
                                $ctrl.code[i] = null;
                            }
                        }, 2000);
                        $timeout(function () {
                            focusOnCodeInput(0);
                        }, 2200);
                    }
                },
                function (error) {
                    $ctrl.codeCheckLoading = false;
                    $ctrl.codeCheckErrorMessage = error.data.message;
                }
            );
    }

    $ctrl.retrySendCode = function () {

        if ($ctrl.retrySendLoading) {
            return;
        }

        $ctrl.retrySendLoading = true;

        $http
            .post('/register/retry-send-code', {register_session_id: $ctrl.registerSessionId})
            .then(
                function () {
                    $ctrl.retrySendLoading = false;
                    resetSendCountdown(60);
                },
                function (error) {
                    $ctrl.retrySendLoading = false;
                    $ctrl.retrySendErrorMessage = error.data.message;
                }
            );
    };

    $ctrl.stepBack = function () {
        $ctrl.step = 1;
    };

    $ctrl.register = function () {

        if ($ctrl.password != $ctrl.passwordConfirm) {
            $ctrl.registerErrorMessage = trans('Password is not same confirm');
            return;
        }

        $ctrl.registerLoading = true;

        $http
            .post('/register', {
                register_session_id: $ctrl.registerSessionId,
                name: $ctrl.name,
                last_name: $ctrl.lastName,
                password: $ctrl.password,
                password_confirmation: $ctrl.passwordConfirm,
                country_code: $ctrl.selectedMask.country_code,
                phone_str: $ctrl.phone,
            })
            .then(
                function (response) {
                    $ctrl.registerLoading = false;
                    let id = response.data.id;
                    let phone = $ctrl.phone.replace(/\D/g, '');
                    Notifier.success(trans('Success registered'), 3);
                    $ctrl.close({$value: {id, name: $ctrl.name, phone, is_admin: false}});
                },
                function (error) {
                    $ctrl.registerLoading = false;
                    if (error.status == 422) {
                        $ctrl.validationErrors = error.data.errors;
                    } else {
                        $ctrl.registerErrorMessage = error.data.message;
                    }
                }
            );
    };

    $ctrl.dismissModal = function (command) {
        $ctrl.dismiss({$value: command});
    };

}
